module.exports = __webpack_public_path__ + "static/media/en-US.d7037ad4.svg";